import { observer } from 'mobx-react-lite';

import { Icons } from '@/assets/icons/icons';
import { IconButton } from '@/components/ui';
import { cn } from '@/lib/utils';
import { userStore } from '@/stores/user.store';

import { sandboxTerminalPanelStore } from './sandbox-terminal-panel.store';

interface SandboxTerminalToggleProps {
  chatId?: string;
  className?: string;
}

export const SandboxTerminalToggle = observer(function SandboxTerminalToggle({
  chatId,
  className,
}: SandboxTerminalToggleProps) {
  if (!userStore.isInternalUser || !chatId) return null;
  const isOpen = sandboxTerminalPanelStore.isSandboxOpenFor(chatId);
  return (
    <IconButton
      size="sm"
      icon={Icons.terminal}
      tooltip="Sandbox terminal"
      aria-label={isOpen ? 'Close sandbox terminal' : 'Open sandbox terminal'}
      className={cn(isOpen && 'bg-surface-hover text-foreground', className)}
      onClick={() => sandboxTerminalPanelStore.toggle(chatId)}
    />
  );
});
